/* eslint-disable no-debugger */
import React, { Fragment } from "react";

import useMeetSanctionStaffFormV3 from "./UseMeetSanctionStaffFormV3";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import Constants from "@usas/ui-web/utils/Constants";
import SearchMemberWithLscPopup from "@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup";

const MeetSanctionStaffFormV3 = ({ 
  savedFormState, 
  onSubmitFormCallback, 
  onBackClicked, 
  OFFICIAL_ORG_ROLE_ID, 
  OFFICIALS_ROLES_ROLE_GROUP_ID,
  meetInfoState
}) => {
  const {
    formState,
    errorState,
    isSubmitting,
    handleSubmit,
    onFormValueChanged,
    setFormState
  } = useMeetSanctionStaffFormV3(savedFormState, onSubmitFormCallback, OFFICIAL_ORG_ROLE_ID, OFFICIALS_ROLES_ROLE_GROUP_ID, meetInfoState);

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup label="Meet Director Member Id*" memberIdName="meetDirectorMemberId" formState={formState} errorState={errorState} setFormData={setFormState} onFormValueChanged={onFormValueChanged} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup label="Meet Referee Member Id*" memberIdName="meetRefereeMemberId" formState={formState} errorState={errorState} setFormData={setFormState} onFormValueChanged={onFormValueChanged} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup label="Meet Contact Member Id*" memberIdName="meetContactMemberId" formState={formState} errorState={errorState} setFormData={setFormState} onFormValueChanged={onFormValueChanged} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup label="Meet Admin Officials Member Id*" memberIdName="meetAdminOfficialMemberId" formState={formState} errorState={errorState} setFormData={setFormState} onFormValueChanged={onFormValueChanged} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Submit</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={() => onBackClicked(formState)}>Back</SecondaryButton>
          </div>
        </div>
      </form >
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isSubmitting} />
    </Fragment>
  );
};

export default MeetSanctionStaffFormV3;